// One paid state, four spellings: Elavon 'completed'; Payroc 'ready' (authorized) / 'complete' (settled); older rows 'approved'. Mirrors backend COMPLETED_STATUSES.
export const PAID_TRANSACTION_STATUSES = ['completed', 'ready', 'complete', 'approved'];

export const COMPLETED_TRANSACTION_STATUSES = [
  'completed',
  'ready',
  'voided',
  'refunded',
  'partially_refunded'
];
